import moment from "moment";
import React, { useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import {
  UPCOMMINGAPIDATA
} from "../../../../services/ApiCalls";

import dataHandler from "../../../../hooks/dataHandler";
import TableActions from "../../../../components/Common/TableActions";
import ButtonLoader from "../../../../components/Common/ButtonLoader";
import { exportCsvHandler } from "../../../../utilities/utilities";
import TableLayout from "../../../../components/TableLayout";
import CustomPagination from "../../../../components/Common/CustomPagination";
import { activeInactiveOptions } from "../../../../utilities/const";
import HotelAdminFilter from "../../../../components/Common/HotelAdminFilter";

const BookingUpcomming = () => {
  const { t } = useTranslation();

  const [exportLoader, setExportLoader] = useState(false);
  const [bookingHistoryStatus, setBookingHistoryStatus] = useState("");

  const {
    setBody,
    body,
    data,
    loader,
    paginationHandler,
    searchHandler,
    total
  } = dataHandler({
    api: UPCOMMINGAPIDATA
  });

  const column = [
    {
      head: t("bookingUpcoming.table.srNo"),
      accessor: "#",
      component: (item, key) => <>{key + 1}</>
    },
    {
      head: t("bookingUpcoming.table.bookingId"),
      accessor: "bookingId",
      component: (item) => (
        <span className="d-block text-truncate">{item?.bookingId}</span>
      )
    },
    {
      head: t("bookingUpcoming.table.bookingType"),
      accessor: "bookingType"
    },
    {
      head: t("bookingUpcoming.table.price"),
      accessor: "price",
      component: (item) => (
        <>{item?.price ? item?.currencySymbol + item?.price : "--"}</>
      )
    },
    {
      head: t("bookingUpcoming.table.discount"),
      accessor: "discount",
      component: (item) => (
        <>{item?.discount ? item?.currencySymbol + item?.discount : "--"}</>
      )
    },
    {
      head: t("bookingUpcoming.table.finalPrice"),
      accessor: "finalPrice",
      component: (item) => (
        <>{item?.finalPrice ? item?.currencySymbol + item?.finalPrice : "--"}</>
      )
    },
    {
      head: t("bookingUpcoming.table.hotelName"),
      accessor: "hotelName",
      component: (item) => <>{item?.hotelDetail?.hotelName || "-"}</>
    },
    {
      head: t("bookingUpcoming.table.hotelId"),
      accessor: "hotelId",
      component: (item) => <>{item?.hotelDetail?.hotelId || "-"}</>
    },
    {
      head: t("bookingUpcoming.table.paymentStatus"),
      accessor: "paymentStatus",
      component: (item) => (
        <span className="text-capitalize">{item?.paymentStatus || "-"}</span>
      )
    },
    {
      head: t("bookingUpcoming.table.userName"),
      accessor: "first_name",
      component: (item) => {
        const firstName = item?.customerDetail?.first_name || "";
        const lastName = item?.customerDetail?.last_name || "";
        return <>{[firstName, lastName].filter(Boolean).join(" ") || "-"}</>;
      }
    },
    {
      head: t("bookingUpcoming.table.checkInTime"),
      accessor: "createdAt",
      component: (item) => (
        <>{moment(item?.checkInDate).format("MM-DD-YYYY , HH:mm")}</>
      )
    },
    {
      head: t("bookingUpcoming.table.checkOutTime"),
      accessor: "createdAt",
      component: (item) => (
        <>{moment(item?.checkOutDate).format("MM-DD-YYYY , HH:mm")}</>
      )
    },
    {
      head: t("bookingUpcoming.table.bookingStatus"),
      accessor: "bookingStatus",
      component: (item) => {
        const status = item?.bookingStatus?.toLowerCase() || "-";
        return (
          <span
            style={{
              backgroundColor: "#f1f1f1",
              borderRadius: "12px",
              padding: "4px 10px",
              fontWeight: "600",
              textTransform: "capitalize"
            }}
          >
            {status}
          </span>
        );
      }
    },
    {
      head: t("bookingUpcoming.table.action"),
      accessor: "action",
      component: (item) => (
        <TableActions
          viewLink={`/upcomming-booking/${item._id}`}
          // editUrl={`/upcomming-booking/edit/${item._id}`}
        />
      )
    }
  ];

  return (
    <section className="orderManagement position-relative py-2">
      <Container>
        <Row>
          <Col lg="12">
            <div className="d-flex justify-content-between">
              <h4 className="mb-0 py-3 fw-bold text-dark">
                {t("bookingUpcoming.title")}
              </h4>

              <Button
                className="d-flex align-items-center commonBtn GreyBtn"
                style={{ height: 40, minWidth: 100, fontSize: 12 }}
                onClick={() =>
                  exportCsvHandler(
                    "bookinghistorycsv",
                    setExportLoader,
                    { status: bookingHistoryStatus }
                  )
                }
              >
                {exportLoader ? <ButtonLoader /> : t("bookingUpcoming.exportCsv")}
              </Button>
            </div>
          </Col>

          <Col lg="12" className="my-3">
            <div className="tableFilter d-flex justify-content-between flex-wrap mb-3">
              <HotelAdminFilter
                body={body}
                searchHandler={searchHandler}
                setBody={setBody}
                statusFilterOptionArr={activeInactiveOptions}
                type="upcomingBooking"
                setFinanceStatus={setBookingHistoryStatus}
              />
            </div>

            <TableLayout column={column} data={data} loader={loader} />

            <CustomPagination
              total={total}
              pageChangeHandler={paginationHandler}
              body={body}
              setBody={setBody}
            />
          </Col>
        </Row>
      </Container>

{/* Tab Theme Styling */}
      <style jsx="true">{`
        .booking-tabs .nav-link {
          background: #f8f9fa;
          border-radius: 8px;
          color: #495057;
          padding: 8px 18px;
          transition: all 0.3s ease;
          border: 1px solid #dee2e6;
        }
        .booking-tabs .nav-link.active {
          background-color: #007bff;
          color: #fff;
          box-shadow: 0 2px 5px rgba(0, 123, 255, 0.3);
        }
        .booking-tabs .nav-link:hover {
          background-color: #e9ecef;
          color: #000;
        }
      `}</style>   
       </section>
  );
};

export default BookingUpcomming;
